globalThis.NotFound = class NotFound {
  constructor() {
    document.title = "Platfo | Not Found";
    document.body.innerHTML = `
      <center>
        <h1>Resource Not Found</h1>
        <p>Click <a href="/">here</a> to go back to browser.</p>
      </center>
    `;
  }

  remove() {
    document.body.innerHTML = "";
  }
};
